import React, { useState, useEffect } from 'react'
import {
  Box,
  Button,
  Divider,
  Select,
  InputGroup,
  InputLeftAddon,
  Input,
} from '@chakra-ui/core'

import dayjs from 'dayjs'
import { setRemoteCall } from '../../../remote'
import { useGlobalState, getGlobalState } from '../../../store'

const ChangeProjectResource = (props) => {
  const { data, relataion, column, setView, setOpen } = props
  const [selectedProject, setSelectedProject] = useState(null)
  const [viewOptions, setviewOptions] = useGlobalState('viewOptions')
  const [endDate, setEndDate] = useState('')
  const [startDate, setStartDate] = useState(viewOptions?.date)
  console.log(viewOptions)
  //get viewdate

  const projects = getGlobalState('projects')
  //Remove resource from project
  const moveResourceToProject = (e) => {
    //then we can add the new relation
    //sanaty check, lest only count if the selected project is different than relation
    if (!selectedProject) {
      return
    }

    setRemoteCall(
      'setRelationToProject',
      {
        dateStart: dayjs(startDate)?.format('DD/MM/YYYY'),
        dateEnd: dayjs(endDate).format('DD/MM/YYYY'),
        projectId: selectedProject,
        accountId: relataion?.accountId,
        resource: data,
        sort: 1,
      },
      null
    )
    setView(null)
    setOpen(false)
  }

  useEffect(() => {
    const thisProjects = projects.find((prj) => prj._id === selectedProject)
    if (thisProjects) {
      setEndDate(thisProjects.endDate)
    } else {
      setEndDate('')
    }
    return () => {}
  }, [selectedProject])

  return (
    <>
      <Select
        size={'sm'}
        placeholder="Selecione uma obra"
        onChange={(e) => setSelectedProject(e.target.value)}
      >
        {projects.map((project) => (
          <option key={project._id} value={project._id}>
            {project?.code} - {project.name}
          </option>
        ))}
      </Select>
      <InputGroup size={'sm'}>
        <InputLeftAddon fontSize={'.8em'} p={'6px'}>
          <i className="icons icon-minus" />{' '}
        </InputLeftAddon>
        <input
          style={{
            width: '80%',
            fontSize: '.8em',
            padding: '0.2em 0.5em',
            border: '1px solid #E2E8F0',
          }}
          textAlign={'right'}
          value={dayjs(endDate)?.format('YYYY-MM-DD') || ''}
          onChange={(e) => setEndDate(e.target.value)}
          type="date"
        />
      </InputGroup>

      <InputGroup size={'sm'}>
        <InputLeftAddon fontSize={'.8em'} p={'6px'}>
          <i className="icons icon-clock" />{' '}
        </InputLeftAddon>
        <input
          style={{
            width: '80%',
            fontSize: '.8em',
            padding: '0.2em 0.5em',
            border: '1px solid #E2E8F0',
          }}
          textAlign={'right'}
          value={dayjs(startDate)?.format('YYYY-MM-DD') || ''}
          onChange={(e) => setStartDate(e.target.value)}
          type="date"
        />
      </InputGroup>

      <Button
        size="sm"
        w={'100%'}
        mt={2}
        onClick={() => moveResourceToProject()}
        className="actionsButton"
        variantColor="red"
        variant="outline"
      >
        <i className="icons icon-share-alt" style={{ marginRight: '4px' }} />
        Mover para obra
      </Button>
      <Button
        w={'100%'}
        size="sm"
        fontSize={'.8em'}
        onClick={() => setView(null)}
        variant="outline"
      >
        Cancelar
      </Button>
    </>
  )
}

export default ChangeProjectResource
